import type { SxProps, Theme } from "@mui/material";
import { HEADER_HEIGHT_CSS_VAR } from "shared-ui/src/constants";


export const colors = {
  white: "#fff",
  overlayBackdrop: "rgba(0,0,0,0.3)",
  sidebarBorderLight: "rgba(0,0,0,0.20)",
  emptyStateText: "rgba(0,0,0,0.6)",
  chevronLight: "rgba(0,0,0,0.45)",
  chevronDark: "rgba(255,255,255,0.7)",
  activeItem: "rgba(34,67,110)",
  toolbarLight: "rgb(41,55,69)",
  toolbarDark: "#232323",
  sidebarLight: "#F7F7F7",
  panelActiveDark: "#121212",
} as const;


export function toolbarBg(mode: "light" | "dark") {
  return mode === "dark" ? colors.toolbarDark : colors.toolbarLight;
}

export function panelActiveBg(mode: "light" | "dark") {
  return mode === "dark" ? colors.panelActiveDark : colors.toolbarLight;
}

export function slideGradient(mode: "light" | "dark") {
  const active = panelActiveBg(mode);
  return `linear-gradient(to right, ${active} 50%, transparent 50%)`;
}

export function chevronIdleColor(mode: "light" | "dark") {
  return mode === "dark" ? colors.chevronDark : colors.chevronLight;
}

export const listItemTextSlotProps = {
  primary: { fontSize: 14, fontWeight: 600 },
} as const;

export const focusVisibleOutline = (theme: Theme) => ({
  outline: "2px solid",
  outlineColor: theme.palette.primary.main,
  outlineOffset: -2,
});

export const interactiveHighlightSx = (theme: Theme) => {
  const bg = `${panelActiveBg(theme.palette.mode)} !important`;
  const focus = focusVisibleOutline(theme);
  return {
    "&:hover": { backgroundColor: bg, color: colors.white },
    "&:focus-visible": { backgroundColor: bg, color: colors.white, ...focus },
  } satisfies SxProps<Theme>;
};

export const SIDEBAR_WIDTH = 280;
export const OVERLAY_TOP = `calc(var(${HEADER_HEIGHT_CSS_VAR}, 60px) + 52px)`;
export const OVERLAY_Z_INDEX = 1200;
export const SUBCATEGORY_Z_INDEX = 99999;

export const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: OVERLAY_TOP,
  left: 0,
  right: 0,
  bottom: 0,
  background: colors.overlayBackdrop,
  zIndex: OVERLAY_Z_INDEX,
};

export const dropdownPaperSx: SxProps<Theme> = {
  mt: 0,
  width: { xs: "92vw", sm: "75vw" },
  maxWidth: "calc(100vw - 50px)",
  minHeight: 260,
  maxHeight: "calc(100vh - 140px)",
  display: "flex",
  overflow: "hidden",
  position: "relative",
  marginBottom: "16px",
};

export const subcategoryPaperSx: SxProps<Theme> = {
  minWidth: 260,
  maxWidth: 320,
  maxHeight: 400,
  overflowY: "auto",
  ml: 0,
};

